import { useNavigate } from 'react-router-dom';
import { Text } from '../text/text.component';
import { OptionIcon } from '../option-icon/option-icon.component';
import { mergeStyle, type Style } from './toolbar-title.module.css';

interface Props {
  title: string;
  style?: Style;
  onGoBack?: () => void;
}

export function ToolbarTitle(props: Props) {

  const { 
    title,
    style: customStyle, 
    onGoBack
  } = props;

  const style = mergeStyle(customStyle);
  const navigate = useNavigate();

  function handleGoBackClick() {
    if (onGoBack) {
      onGoBack();
    } else {
      navigate(-1);
    }
  }

  return (
    <div className={style.container}>
      <OptionIcon 
        className={style.icon} 
        icon='arrow_back'
        onClick={handleGoBackClick}/>
      <Text 
        className={style.title} 
        text={title}/>
    </div>
  );
}
